import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import browser from "web/script/utils/browser";
import withReduxProvider from "web/react/redux-provider";
import { BrandAdContainerProps } from "web/react/components/brand-ad-container/brand-ad-container";
import ProfileHeaderWithLogo, {
    RelatedBrand,
} from "web/react/components/profile-header/profile-header-with-logo";
import { triggerBanner, setDesignerProfile } from "web/redux/ducks/follow-designer-banner";

export interface ProfileProps {
    follow_button?: {
        lyst_id: number;
        registration_reason?: string;
        followed_text: string;
        notfollowed_text: string;
        notfollowed_text_top: string;
        is_authenticated: string;
        is_following: string;
        ios_sticky_description: string;
        designer_name: string;
        product_taxonomy?: string;
    };
    small_photo_url: string;
    name?: string;
    title?: string;
    retailer_hub_link?: string;
    brand_ad?: BrandAdContainerProps;
    features?: {
        pmt_brand_ads?: boolean;
    };
    slug: string;
}

export interface ProfileHeaderProps {
    profile: ProfileProps;
    shopHeader?: boolean;
    relatedDesigners?: RelatedBrand[];
}

function getInView(bounding: DOMRect): boolean {
    return (
        bounding.top >= -bounding.height &&
        bounding.left >= -bounding.width &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function ProfileHeader({
    profile,
    relatedDesigners,
    shopHeader,
}: ProfileHeaderProps): JSX.Element {
    const followCTARef = useRef<HTMLDivElement>(null);
    const [isIos, setIsIos] = useState(false);
    const dispatch = useDispatch();

    dispatch(setDesignerProfile(profile));

    useEffect(() => {
        function onScroll(): void {
            if (followCTARef.current) {
                let bounding = followCTARef.current.getBoundingClientRect();
                dispatch(triggerBanner(!getInView(bounding)));
            }
        }
        window.addEventListener("scroll", onScroll);
        return (): void => {
            window.removeEventListener("scroll", onScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (followCTARef.current) {
            let bounding = followCTARef.current.getBoundingClientRect();
            dispatch(triggerBanner(!getInView(bounding)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [followCTARef.current]);

    useEffect(() => {
        setIsIos(browser.ios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browser.ios]);

    let title = shopHeader ? profile.title : profile.name;

    if (!title) {
        return <></>;
    } else {
        return (
            <ProfileHeaderWithLogo
                title={title}
                profile={profile}
                followCTARef={followCTARef}
                isIos={isIos}
                relatedDesigners={relatedDesigners}
            />
        );
    }
}

export default withReduxProvider(ProfileHeader);
